
import { component } from '@/helpers/vueTyped';
import store, { mapState, dispatch } from '@/store';
import { TournamentSport, Tournament } from '@/components/Sport/types';
import router from '@/router';
import TournamentSelect from './TournamentSelect.vue';

interface TournamentSelectContainerProps {
  options: TournamentSport;
  closeCallback?: () => any;
}

export default component<TournamentSelectContainerProps>()({
  name: 'TournamentSelectContainer',

  props: {
    options: {},
    closeCallback: {
      type: Function,
      default: () => null,
    },
  },

  data() {
    return {
      isOpen: false,
    };
  },

  computed: {
    ...mapState(['navigationState']),

    tournamentIdNameMap(): { [key: string]: Tournament } {
      const flatTournaments = this.options.groups
        .map((groups) => groups.tournaments)
        .reduce((acc, cur) => {
          acc.push(...cur);
          return acc;
        }, [] as Tournament[]);

      flatTournaments.push(...this.options.tournaments);
      flatTournaments.push({
        label: `All ${this.options.label}`,
        id: this.options.id,
        providerId: this.options.providerId,
        legacyId: this.options.legacyId,
        sport: this.options.sport,
        classification: this.options.classification,
      });

      return flatTournaments.reduce((acc, cur) => {
        acc[cur.id] = cur;
        return acc;
      }, {} as { [key: string]: Tournament });
    },

    selectedTournament(): Tournament {
      const { tournament } = this.navigationState;
      dispatch('setSelectedTournament', [
        this.tournamentIdNameMap[tournament!],
      ]);
      return this.tournamentIdNameMap[tournament!];
    },

    sportTournamentRoute(): string {
      const { sport, tournament } = this.navigationState;
      return `/${sport}/${tournament}`;
    },
  },

  methods: {
    focused() {
      router.push(this.sportTournamentRoute).catch((err) => {
        if (err.from.name === err.to.name) {
          return;
        }
        throw err;
      });
    },

    open() {
      this.isOpen = true;
    },

    close() {
      this.closeCallback!();
      this.isOpen = false;
    },
  },

  render() {
    return (
      <div class='tour-div' onClick={this.open} onFocus={this.focused}>
        <div class='tour-menu-item'>
          <div class='tour-label'>{this.selectedTournament.label}</div>
          <img class='menu-arrow' src='/svg/down-arrow-white.svg' />
        </div>
        {this.isOpen && (
          <portal>
            <transition name='fade'>
              <TournamentSelect
                selectedTourId={this.selectedTournament.id}
                options={this.options}
                menuClosedCallback={this.close}
              />
            </transition>
          </portal>
        )}
      </div>
    );
  },
});

// VUE JSX HOT LOADER //
if (module.hot) require("/github/workspace/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-4b9903b4/TournamentSelectContainer.vue" });